import React, {  Suspense,  } from "react";
import { Helmet } from "react-helmet-async";

import { Styles } from "./IncomingCandidates";
import { colors } from "../../utils/Colors";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";
import IncomingCandidatesList from "../../components/Candidates/IncomingCandidatesList";

const IncomingCandidates = () => {
  return (
    <Styles colors={colors}>
      <Helmet>
        <title>Incoming Candidates - GigFalcon</title>
        <meta
          name="description"
          content="Review and manage incoming candidates for your job postings on GigFalcon. Find the best talent for your projects."
        />
      </Helmet>
      <Header />
      <section className="container manage-orders">
        <h2>
        Incoming <span className="falcon-clr">Candidates</span>
        </h2>
        
        <IncomingCandidatesList />
        
      </section>
      <Footer />
    </Styles>
  );
};

export default IncomingCandidates;
